// TD Logo Component for Light Mode
export const TDLogoFull = () => (
  <svg width="120" height="40" viewBox="0 0 120 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="4" fill="#00A950"/>
    <text x="20" y="27" fontFamily="Arial, sans-serif" fontSize="20" fontWeight="bold" fill="white" textAnchor="middle">TD</text>
    <text x="75" y="25" fontFamily="Arial, sans-serif" fontSize="14" fontWeight="600" fill="#00A950">TD Bank</text>
  </svg>
);

// TD Logo Icon Component (collapsed sidebar)
export const TDLogoIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="4" fill="#00A950"/>
    <text x="20" y="27" fontFamily="Arial, sans-serif" fontSize="20" fontWeight="bold" fill="white" textAnchor="middle">TD</text>
  </svg>
);

// TD Logo Component for Dark Mode (Full)
export const TDLogoFullDark = () => (
  <svg width="120" height="40" viewBox="0 0 120 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="4" fill="#00A950"/>
    <text x="20" y="27" fontFamily="Arial, sans-serif" fontSize="20" fontWeight="bold" fill="white" textAnchor="middle">TD</text>
    <text x="75" y="25" fontFamily="Arial, sans-serif" fontSize="14" fontWeight="600" fill="#4FBF7F">TD Bank</text>
  </svg>
);

// TD Logo Icon Component for Dark Mode (collapsed sidebar)
export const TDLogoIconDark = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="4" fill="#00A950"/>
    <text x="20" y="27" fontFamily="Arial, sans-serif" fontSize="20" fontWeight="bold" fill="white" textAnchor="middle">TD</text>
  </svg>
);